import { useEffect, useState } from 'react'
import { fdeProjectPath, fdeRoutes } from '@/frontend/features/Fde/routes'
import type { OntologyChange } from '@/frontend/features/Fde/types'

export default function useOntologyHistory(projectId: string, recordType?: 'element' | 'relationship', recordId?: string) {
  const [items, setItems] = useState<OntologyChange[]>([])
  const [loading, setLoading] = useState(false)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    if (!recordType || !recordId) {
      setItems([])
      setLoading(false)
      setFailed(false)
      return
    }

    const controller = new AbortController()
    setLoading(true)
    setFailed(false)
    fetch(fdeProjectPath(fdeRoutes.ontologyHistory, projectId, { record_type: recordType, record_id: recordId }), {
      headers: { Accept: 'application/json' },
      signal: controller.signal,
    })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.json() as Promise<{ items: OntologyChange[] }>
      })
      .then((payload) => setItems(payload.items))
      .catch((error: unknown) => {
        if (!(error instanceof DOMException && error.name === 'AbortError')) setFailed(true)
      })
      .finally(() => { if (!controller.signal.aborted) setLoading(false) })

    return () => controller.abort()
  }, [projectId, recordId, recordType])

  return { items, loading, failed }
}
